module.exports = __webpack_public_path__ + "img/80c25c5924fd7ddfdc0fec3b374667b0.1b730d5b.jpg";